const state = {
  productHeader: {
    title: [
      "<span class='yellowColor'> بەرهەمەکانمان </span>",
      "<span class='yellowColor'>الخدمات</span>",
      "Our <span class='yellowColor'>Products</span>"
    ],
    discription: [
      "بەرهەمەکانمان بە باشترین و نوێترین تەکنەلۆجیاکان دروست ئەکەین وە بە شێوەیەکی بەردەوام پاڵپشتی بەشداربوەکانمان دەکەین",
      "نصنع منتجاتنا بأحدث التقنيات وندعم عملائنا بشكل مستمر",
      "We create our products with the newest technologies and we support our clients continuously"
    ]
  },
  products: [
    {
      id: 1,
      title: [
        "سیستەمی ژمێریاری بۆ کۆمپانیا گەشتیاریەکان",
        "نظام المحاسبة لشركات السفر والسياحة",
        "Travel Agency Accounting"
      ],
      discription: [
        "تایبەتە بەو کۆمپانیایاخودەی کە لە بواری گەشت و گوزاردا کار دەکەن، وە یارمەتی دەرێکی باشە بۆ خێراتر کردنی کارەکانی کۆمپانیا",
        "هذا التطبيق مخصص لشركات السفر والسياحة ، فهو يساعد في تقليل وقت المحاسبة ويجعل العمل أسهل",
        "This application is for Travel and Tourism companies, it helps to reduce accounting time and makes work easier"
      ],
      features: [
        [
          "هەمە جۆری پارە: بەکارهێنەر بەپێی ویستی خۆی ئەتوانێ جۆری پارە کەم و زیاد بکات وەک (دیناری عێڕاقی، دۆلاری ئەمریکی، ...).",
          "العملات المتعددة: يمكن للمستخدم تعديل وإضافة أنواع العملات اعتمادًا على الاستخدام مثل ( الدينار العراقي,الدولار الامريكي)",
          "Multiple currency: user can modify and add types of currency depend on usage such as (IQD, USD)."
        ],
        [
          "بریکار و کڕیار : لەم بەشەدا بەکارهێنەر ئەتوانێ ئەو کەسانە زیاد بکات کە کاری لەگەڵدا ئەکات.",
          "الممون والعميل : في هذا القسم ، يمكن للمستخدم إضافة هؤلاء العملاء والممونين الذين يعملون معهم.",
          "Supplier & Client : in this section user can add those clients and suppliers whom they are working with."
        ],
        [
          "پسوڵە : بەشیکی سەرەکی سیستەمەکەیەو هەموو ئەو ئیش و کارانە لەخۆ ئەگرێ کە ئەنجام دراوە لە نێوان کۆمپانیا و ئەو شوێنانەی کە کاری لەگەڵدا ئەکات و زانیاری تەواوی تێدایە لەبارەی هەریەک لە کارەکان.",
          "الفاتورة : تعد أحد الأقسام الأساسية في النظام التي تتضمن جميع تلك الأنشطة التجارية التي تتم بين الشركة وأماكن أخرى وتحتوي على كافة التفاصيل عن كل إجراء.",
          "Invoice : This is one of the base sections in the system which includes all those businesses done between the company and other places and it has a detail of each action."
        ],
        [
          "ڕاپۆرت : ئەم بەشە تایبەتە بە پیشاندانی بڕی قازانج لە ماوەیەکی دیاریکراودا کە یارمەتی دەرێکی زۆر باشە بۆ کۆمپانیا تاکو بزانێ باری دارایی کۆمپانیا لە چ ئاستێکدایە.",
          "التقرير : يهدف هذا القسم إلى إظهار الربح في فترة محددة ، وهذا مفيد جدًا للشركة لمعرفة الوضع الاقتصادي للشركة.",
          "Report : this section is for showing profit in specific period, this is very helpful for the company to know the economy situation of the company."
        ]
      ],
      profile: "travel-agency.jpg",
      images: ["travel1.png", "travel2.png", "travel3.png"]
    },
    {
      id: 2,
      title: [
        "سیستەمی داوا کردنی ئۆنلاین",
        "نظام الطلب عبر الإنترنت",
        "Online Ordering System"
      ],
      discription: [
        "ئەم سیستەمە تایبەتە بەو کۆمپانیایاخودەی کە شت و مەک لە دەرەوەی ووڵات هاوردە دەکەن بە پێی خواستی بەکارهێنەران.",
        " هذا النظام مخصص لتلك الشركات التي تشتري اغراض من خارج البلاد حسب طلب المستخدم.",
        "This system is for those companies who buy items abroad as per user order."
      ],
      features: [
        [
          ".داخڵ بون لە ڕێی تۆڕی کۆمەڵایەتی فەیسبووک یاخود گووگڵ",
          "تسجيل الدخول بحساب الفيسبوك أو  جي ميل.",
          "Login with Facebook or Gmail account."
        ],
        [
          "پشاندانی باری ئەو شت و مەکەی کە کڕیار داوای کردووە بۆ نموونە (داواکراوە، کڕاوە، گەڕێنراوەتەوە، وەگیراوە) وە چەندین جۆر باری تر کە ئەمەش دڵنیایی ئەدات بە بەکارهێنەری ئاسایی. ",
          "عرض الحالة للغرض المطلوب مثل الذي (تم طلبه، عمليات الشراء ،العمليات التي تم إلغاؤها ,وكذلك تسليمها) والحالات الأخرى التي تمنح الثقة للمستخدم العادي.",
          "Show the status of item ordered such as (ordered, purchases, canceled, delivered) and other statuses which give a certainty to a normal user."
        ],
        [
          "ئاگادار کردنەوەی بەکارهێنەری ئاسایی لە بارەی ئەو شت و مەکەی داوای کردووە لە ڕێی ئیمەیڵ یاخود کورتە نامە.",
          "تنبيه المستخدم العادي بشأن حالة الطلب عن طريق البريد الإلكتروني أو الرسائل القصيرة.",
          "Alert normal user about item status with email or SMS."
        ],
        [
          "ئاگادارکردنەوە(نۆتیفیکەیشن) کە ئەدمین ئاگادار ئەکاتەوە هەر کاتێک داواکارییەکی نوێ هەبێ لە لایەن کڕیارەکانیەوە. ",
          "يتم تنبيه المشرف (الادمن) عن طريق الاشعار في حالة وجود طلب جديد من قبل العملاء",
          "Notification that alert the admin about new order that requested by customers."
        ]
      ],
      profile: "online-ordering.jpg",
      images: []
    },
    {
      id: 3,
      title: ["سیستەمی ژمێریاری مخزەن", "نظام المخزن", "Inventory System"],
      discription: [
        "تایبەتە بە بواری ژمێریاری بۆ (مارکێت، کۆگا) یاخود هەر شوێنێک کا کاری کڕین و فرۆشتن بکات",
        "هذا لأغراض المحاسبة والإدارة ، لأي مكان عمل مثل (السوق ، المخزون) أو أي أفراد أو شركات أخرى تقوم بالبيع والشراء",
        "This is for accounting and management purpose for any workplace such as (market, inventory) or any other individuals or companies who do sale and purchase"
      ],
      features: [
        [
          "ڕێپێدان: ئەدمین ئەتوانێ ئەو کەسانە داخڵی سیستەم بکات کە کاری لەگەڵ دەکەن وە بۆ هەر کەسێک ڕێپێدانی جیاواز دا بنێ کە ئەو کەسە ئەتوانێ چ کارێک ئەنجام بدات لە سیستەمەکەدا.",
          "الرخصة : يمكن للمستخدم المسؤول إضافة المستخدمين الذين يعملون معهم ومنح كل منهم رخصة مختلفة والتي تحدد للمستخدم  الاجراءات التي يمكنه القيام بها.",
          "Permission : admin user can add users who working with and give each of them a different permission which determine which user can do which action."
        ],
        [
          "زمان : ئەم سیستەمە بە هەرسێ زمانی (کوردی، عەرەبی، ئنگلیزی) بەردەستە وە ئەتوانرێ بەپێی خوستی بەکارهێنەر هەر زمانێکی تری بۆ زیاد بکرێت.",
          "اللغات المتعددة : يدعم هذا النظام اللغة (الكردية والعربية والإنجليزية) ويمكننا إضافة أي لغة أخرى حسب طلب العميل.",
          "Multiple language : this system support (Kurdish, Arabic, and English) and we can add any other language as per client’s request."
        ],
        [
          "فرە کۆگا : کەسی بەکارهێنەر گەر هاتوو لە کۆگایەک زیاتری هەبوو ئەوا زۆر بە ئاسانی ئەتوانێ کۆگاکانی داخڵ بکات وە لە کاتی کڕین و فرۆشتن ئەتوانێ کۆگا دیاری بکات و زانیاری هەر یەکێکیاخود بە جیا ببینێ.",
          "مخزن متعدد : إذا كان لدى المستخدم مخزن متعدد ، فبإمكانه ببساطة إضافته ، وعند الشراء أو البيع ، يمكنه تحديد المخزن ومشاهدة كل تفاصيل المخزن.",
          "Multiple inventory : if user have multiple inventory he/she can simply add it and when doing purchase or sale he/she can select the inventory and see each inventory detail."
        ],
        [
          "ئاگادارکردنەوە (نۆتیفیکەیشن) : سیستەمەکە ئاگادارت ئەکاتەوە لەو پسوڵەی فرۆشتنانەی کا ماوەی پارەدانیاخود بەسەرچووە و پارەکەی نەدراوە.",
          "إشعار : كذلك يوفر النظام خاصية الاشعار التي تؤدي  إلى تنبيه المستخدم بفواتير المبيعات التي تأخرت عن فترة الدفع.",
          "Notification : this will alert user about those sales invoices which overdue its payment term."
        ],
        [
          "خەرجی : تایبەتە بەو خەرجییە لاوەکییاخودەی کە خاوەن کار ئەیکات وەک (کرێی مانگانە، موچەی کارمەند) یاخود هەر جۆرە خەرجییەکی تر.",
          "المصاريف : خاص هذا لمصاريف الشركة مثل (الإيجار ، الراتب) أو أي مصاريف أخرى.",
          "Expense : this is for company’s expenses such as (Rent, salary) or any other expenses."
        ]
      ],
      profile: "mirk-accounting.jpg",
      images: [
        "mirka-accounting1.png",
        "mirka-accounting2.png",
        "mirka-accounting3.png",
        "mirka-accounting4.png"
      ]
    },
    {
      id: 4,
      title: [
        "سیستەمی بەڕێوەبردن بۆ ڕێستۆرانت",
        "نظام إدارة المطاعم",
        "Restaurant Management System"
      ],
      discription: [
        "باشترین سیستەم بۆ بەڕێوەبردنی هەموو جۆرە ڕێستۆرانت و فاست فوودێک کە چەندین تایبەتمەندی ناوازەی هەیە.",
        "إنه برنامج مثالي لإدارة المطاعم والوجبات السريعة وله الكثير من الميزات الجيدة",
        "It is a perfect software for restaurant and fast food management and it has a plenty of good features"
      ],
      features: [
        [
          "لە هەرشوێنێک بیت ئەتوانی ئاگاداری هەموو حسابات و ئیشێکی ناو ڕێستۆرانتەکەت بیت",
          "من أي مكان وفي أي وقت يمكنك الحصول على معلومات حول الحسابات وكيفية سير العمل.",
          "From anywhere and anytime you can get to know about accounting and how works going from your restaurant."
        ],
        [
          "لەسەرجەم ئامێرەکانی وەک کۆمپیوتەر و تابلێت و مۆبایلێکی زیرەک کاردەکات.",
          "يتلائم مع جميع أجهزة الكومبيوتر والأجهزة اللوحية والهواتف الذكية.",
          "Compatible with any computers and tablets and smart phones."
        ],
        [
          "بە ٣ زمان ( کوردی ، عەرەبی، ئینگلیزی ) کاردەکات.",
          "يدعم اللغة الكردية والعربية والإنجليزية.",
          "Support Kurdish, Arabic and English language."
        ],
        [
          "ئامادەکردنی زیاتر لە ٦ جۆر ڕاپۆڕتی جیاواز  وەک ڕاپۆرت بە پێی وەسڵ، ڕاپۆڕت بەپێی کاڵا، وە زۆر جۆری تر.",
          "يقوم بإعداد أكثر من 6 تقارير مختلفة مثل تقرير الوصفات وتقرير العناصر وأكثر من ذلك بكثير.",
          "Prepares more than 6 different reports like recipe report, item report and much more."
        ],
        [
          "زانیاری تەواو دەربارەی هەموو مێزەکان.",
          "كامل المعلومات حول جميع الطاولات في مطعمك.",
          "Total information about all tables in your restaurant."
        ],
        [
          "ڕیکخستنی کار و باری دلیڤەری و زانیاری تەواو دەربارەی هەر دلیڤەرییەک.",
          "تنظيم وادراة التوصيل و طلبات الزبائن واعطاء كافة المعلومات عن كل عملية توصيل .",
          "Managing delivery and customer orders, and giving detail information about each delivery."
        ],
        ["دانانی داشکاندن.", "ضبط الخصم للعناصر", "Setting discount for items."]
      ],
      profile: "restaurant.jpg",
      images: []
    }
  ],
  productInfo: {}
};

const getters = {
  listOfProducts: state => state.products,
  productHeader: state => state.productHeader,
  productInfo: state => state.productInfo
};

const actions = {
  getProductById({ commit }, id) {
    commit("getProductById", id);
  }
};

const mutations = {
  getProductById: (state, id) => {
    let obj = state.products.find(x => x.id === parseInt(id));
    state.productInfo = obj;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
